import React, { Component, PropTypes } from 'react';
import { sessionKey } from './../store/cookies.js';
import { basePathname } from './../store/history.js';
import register from './../register/register.js';
import Cookies from './../libs/tomcat-cookies.js';

class Register extends Component {
	componentWillMount() {
		// Remove cookie entry from previous registration.
		if (this.props.location.pathname === '/register') {
			if (Cookies.get('registrationStepTwo')) {
				Cookies.remove('registrationStepTwo');
			}
		}

		const { push } = this.props.history;
		if (sessionKey()) {
			push(basePathname());
		} else {
			register().open('register');
		}
	}

	componentWillUnmount() {
		register().close();
	}

	render() {
		return (<div id="register" />);
	}
}

Register.propTypes = {
	history: PropTypes.object
};

export default Register;



// WEBPACK FOOTER //
// ./mobile-core/src/components/register.js